import { h4Styles } from 'components/reusable-css';
import styled, { css } from 'styled-components';
import { deviceBreakpoints, variables } from 'variables';

export const SettingPanel = styled.div`
  background: ${(props) => props.theme.panelBackground};
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  padding-top: 30px;
  background: white;
`;

export const Start = styled.div`
  padding: 10px 30px 2em 30px;
  display: flex;
  h5 {
    margin: 0;
  }
  @media (max-width: 768px) {
    padding: 10px 20px;
  }
  i {
    color: ${(props) => props.theme.primaryDarkColor};
    cursor: pointer;
    margin-left: 20px;
    margin-top: 5px;
  }
`;

export const CrossIcon = styled.div`
  i {
    color: ${(props) => props.theme.primaryDarkColor};
    cursor: pointer;
    margin-right: 20px;
  }
`;

export const RenameModal = styled.div`
  border: 1px solid transparent;
  background: white;
  border-radius: 15px;
  width: 500px;
  padding: 15px 1.5em 2em 1.5em;
  @media (max-width: 500px) {
    width: 100%;
  }
`;

export const GreyBorder = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.serverSizeCard.borderColor};
  padding: 6px 0;
`;

export const NewTag = styled.div`
  margin-top: 1em;
  i {
    color: ${(props) => props.theme.primaryDarkColor};
    font-size: 14px;
    cursor: pointer;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 2.5em;
  display: flex;
  justify-content: flex-end;
`;

export const Content = styled.div`
  padding: 1em 1em 2em 2.1em;
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const flexContainer = styled.div`
  display: flex;
`;

export const NewflexContainer = styled.div`
  display: flex;
  padding: 2em 0 1em 0;
`;

export const BlueInfo = styled.div`
  display: flex;
  background: #008dc3;
  padding: 1em 10px;
  border-radius: 5px;
  i {
    color: white;
    margin-right: 5px;
    margin-top: -2px;
  }
  p {
    color: white;
    margin: 0;
    margin-top: -2px;
  }
`;

export const Card = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.4fr 0.3fr 0.4fr 0.8fr 0.8fr 0.5fr 0.6fr;
  width: 100%;
  padding: 12px 16px;
  background: white;
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  opacity: ${(props) => (props.isDeleted == 1 ? 0.5 : 1)};
  pointer-events: ${(props) => (props.isDeleted == 1 ? 'none' : 'auto')};
  &:hover {
    background: ${(props) =>
      props.isDeleted == 1 ? 'transparent' : props.theme.serverSizeCard.features.hoverBackgroundColor};
  }
`;

export const MobileCard = styled.div`
  margin-top: 15px;
  width: 100%;
  padding: 12px 0;
  background: white;
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  opacity: ${(props) => (props.isDeleted == 1 ? 0.5 : 1)};
  pointer-events: ${(props) => (props.isDeleted == 1 ? 'none' : 'auto')};
  &:hover {
    background: ${(props) =>
      props.isDeleted == 1 ? 'transparent' : props.theme.serverSizeCard.features.hoverBackgroundColor};
  }
`;

export const Headers = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.4fr 0.3fr 0.4fr 0.8fr 0.8fr 0.5fr 0.6fr;
  padding: 12px 16px;
  margin-top: 2em;
  p {
    font-weight: bold;
  }
`;

export const Column = styled.div`
  display: flex;
  align-items: center;
  .orange-text {
    color: ${(props) => props.theme.primaryDarkColor} !important;
  }
`;

export const SingleColumn = styled.div`
  display: flex;
  align-items: center;
  padding-right: 10px;
  .text-link {
    text-decoration: underline;
    cursor: pointer;
    color: #007bff;
  }
  p {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const SingleColumnMobile = styled.div`
  .text-link {
    text-decoration: underline;
    cursor: pointer;
    color: #007bff;
  }
  p {
    margin: 0;
  }
`;

export const FlexBetweenColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  flex-wrap: wrap;
`;

export const FlexBetweenColumnBorder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(props) => props.theme.serverSizeCard.borderColor};
  border-top: 1px solid ${(props) => props.theme.serverSizeCard.borderColor};
  padding: 0.6em 16px;
  margin: 0.6em 0;
  flex-wrap: wrap;
`;

export const ActionBadge = styled.span`
  background: ${(props) => (props.type == 'allow' ? '#ecf8e7' : '#fdeaeb')};
  color: ${(props) => (props.type == 'allow' ? '#59c025' : 'red')};
  padding: 4px 8px;
  border-radius: 6px;
  text-transform: capitalize;
`;

export const MobileActionBadge = styled.div`
  background: ${(props) => (props.type == 'allow' ? '#ecf8e7' : '#fdeaeb')};
  color: ${(props) => (props.type == 'allow' ? '#59c025' : 'red')};
  padding: 4px 8px;
  border-radius: 6px;
  text-transform: capitalize;
  margin-top: 2px;
`;

export const Icon = styled.div`
  padding: 4px;
  margin-left: 8px;
  cursor: pointer;
  i {
    cursor: pointer;
    color: ${(props) => props.theme.primaryDarkColor};
    font-size: 18px;
  }
`;

export const ThreeDotsIcon = styled.div`
  padding: 4px;
  margin-left: 5px;
  cursor: move;
  i {
    cursor: pointer;
    color: ${(props) => props.theme.primaryDarkColor};
    font-size: 18px;
  }
`;

export const StyledPlusIcon = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #59c025;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  z-index: 1000;
  margin: -10px 8px;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    font-size: 28px;
  }
`;

export const CloseContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1em;
  i {
    color: black;
    font-size: 20px;
    cursor: pointer;
  }
`;

export const ListContainers = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormWrapper = styled.div`
  background: white;
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  margin-top: 15px;
  padding: 10px 10px 0 20px;
  width: 70%;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

export const Section = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
`;

export const SourceContainer = styled.div`
  margin: 20px 0;
  background: ${(props) => props.theme.serverSizeCard.features.backgroundColor};
  padding: 1.5em 1em;
  border-radius: 5px;
`;

export const RadioCard = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  width: 380px;
  cursor: pointer;
  @media (max-width: 1000px) {
    margin-top: 0;
  }
`;

export const RadioPortCardContainer = styled.div`
  margin-top: 1em;
`;

export const RadioPortCard = styled.div`
  display: flex;
  align-items: center;
  margin: 5px 0;
  cursor: pointer;
`;

export const RadioContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5em;
  h6 {
    margin: 0;
  }
  .para {
    padding: 0 8px;
  }
  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`;

export const SectionFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1em;
  padding-right: 1em;
  h6 {
    margin: 0;
  }
  @media (max-width: 1000px) {
    flex-wrap: wrap;
    h6 {
      margin: 0;
      margin-bottom: 1rem;
    }
  }
`;

export const SectionButton = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
`;

export const Width50 = styled.div`
  width: 15em;
`;

export const FlexContainerAction = styled.div`
  display: flex;
  align-items: center;
  h6 {
    margin: 0;
    margin-top: -5px;
    margin-left: 10px;
  }
`;

export const RulesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3em;
  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`;
export const EditNewRuleSty = styled.div`
  color: white;
  border-radius: 20px;
  padding: 8px 12px 8px 8px;
  display: flex;
  justify-content: center;
  width: 14em;
  margin-bottom: 10px;
  p {
    white-space: nowrap;
    margin: 0;
    font-weight: bold;
  }
  i {
    margin-right: 10px;
    margin-top: -1px;
  }
`;
export const AddNewRuleSty = styled.div`
  background-color: #59c025;
  color: white;
  border-radius: 20px;
  padding: 8px 12px 8px 8px;
  display: flex;
  justify-content: center;
  width: 14em;
  margin-bottom: 10px;
  p {
    white-space: nowrap;
    margin: 0;
    font-weight: bold;
  }
  i {
    margin-right: 10px;
    margin-top: -1px;
  }
`;

export const AddRuleText = styled.div`
  margin-right: 3.5em;
  @media (max-width: 1000px) {
    width: 100%;
    margin-top: 1em;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 0;
  }
`;

// ------------------------------------ Objects -----------------------------------
export const Step3SC = styled.div`
  background: white;
  padding: 60px ${variables.pageContentPadding}px;
  width: 100%;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
  @media only screen and (max-width: ${deviceBreakpoints.mobile}px) {
    padding: 0 ${variables.pageContentPadding}px;
  }
`;

export const ObjectSC = styled.div`
  margin-top: 20px;
`;

export const StepDescription = styled.div`
  margin-top: 55px;
  @media only screen and (max-width: ${deviceBreakpoints.mobile}px) {
    margin-top: 2em;
  }
`;

export const ObjectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 10px;
  padding-right: 14px;
`;

export const Features = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1em;
  background: ${(props) => props.theme.serverSizeCard.features.backgroundColor};
`;

export const EditContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
  padding-bottom: 1.5em;
  width: 100%;
  background: ${(props) => props.theme.serverSizeCard.features.backgroundColor};
`;

export const ObjectCardSC = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 320px;
  width: 100%;
  height: 280px;
  background: ${(props) => props.theme.gray.shadeF};
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  overflow: hidden;
  transition: all 150ms ease;
  @media only screen and (max-width: 649px) {
    height: auto;
  }
  &:hover {
    background: ${(props) => props.theme.serverSizeCard.hoverBackgroundColor};
    border-color: ${(props) => props.theme.serverSizeCard.hoverBorderColor};

    ${Features} {
      background: ${(props) => props.theme.serverSizeCard.features.hoverBackgroundColor};
    }
    ${EditContainer} {
      background: ${(props) => props.theme.serverSizeCard.features.hoverBackgroundColor};
    }
  }

  ${(props) =>
    props.selected &&
    css`
      border-color: ${(props) => props.theme.primaryColor};
    `};
`;

export const FlexCon = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  @media only screen and (max-width: ${deviceBreakpoints.mobile}px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const Name = styled.div`
  display: flex;
  font-size: ${(props) => props.theme.default?.h4};
  ${(props) => h4Styles(props.theme.resolutions)};
`;

export const NameContainer = styled.div`
  padding: 1em 10px;
  white-space: nowrap !important;
`;

export const Feature = styled.div`
  display: flex;
  width: 48%;
  p {
    line-height: 2em;
  }
  i {
    color: ${(props) => props.theme.primaryColor};
    margin-right: 6px;
    line-height: 2em;
  }
  @media only screen and (max-width: 649px) {
    margin-bottom: 10px;
    p {
      line-height: 1.2em;
    }
    i {
      line-height: 1.2em;
    }
  }
`;

export const SeeFeature = styled.div`
  display: flex;
  cursor: pointer;
  p {
    line-height: 2em;
    color: #007bff;
    font-weight: bold;
    text-decoration: underline;
  }
  @media only screen and (max-width: 649px) {
    margin-right: 6px;
    margin-bottom: 10px;
    p {
      line-height: 1.2em;
    }
  }
  i {
    color: transparent;
    margin-right: 6px;
    line-height: 2em;
  }
`;

export const EditButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 2em;
  background: ${(props) => props.theme.primaryDarkColor};
  border-radius: 5px;
  cursor: pointer;
  i {
    color: white;
    margin-right: 6px;
    margin-top: -8px;
  }
  p {
    color: white;
    margin: 0;
    font-weight: bold;
  }
`;

export const flexObjectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`;

export const ObjectContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const ObjectInputContainer = styled.div`
  width: 48%;
  margin-top: 1em;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

export const ObjectInputContainers = styled.div`
  padding: 2em 1em;
  border-radius: 10px;
  background: ${(props) => props.theme.serverSizeCard.features.hoverBackgroundColor};
`;

export const ObjectContainerInput = styled.div`
  margin-bottom: 1.5em;
`;

export const ObjectIpList = styled.div`
  width: 48%;
  margin-top: 1em;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

export const PanelFeature = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 15px;
  opacity: ${(props) => (props.isDeleted == 1 ? 0.5 : 1)};
  pointer-events: ${(props) => (props.isDeleted == 1 ? 'none' : 'auto')};
  .delete {
    color: ${(props) => props.theme.primaryColor};
    margin-left: 6px;
    cursor: pointer;
  }
  &:hover {
    background: ${(props) =>
      props.isDeleted == 1 ? 'transparent' : props.theme.serverSizeCard.features.hoverBackgroundColor};
  }
`;

export const PanelFirstFeature = styled.div`
  display: flex;
  p {
    line-height: 3em;
  }
  i {
    color: ${(props) => props.theme.primaryColor};
    margin-right: 6px;
    line-height: 3em;
  }
`;

export const ObjectIpListFlex = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap-reverse;
  width: 100%;
  margin-top: 1em;
`;

export const ObjectCardPanelSC = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${(props) => props.theme.gray.shadeF};
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  transition: all 150ms ease;
`;
